export const MAX_2_DECIMAL_NUMBER_REGEX = /^\d+(\.\d{1,2})?$/;

export const UUID_REGEX =
  /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/i;
